module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "player-cell"
  }, [_c('div', {
    staticClass: "player-puce",
    style: ({
      'background-color': _vm.cellData.color
    })
  }), _vm._v(" "), _c('p', {
    staticClass: "player-name"
  }, [_vm._v(_vm._s(_vm.cellData.name))]), _vm._v(" "), _c('div', {
    staticClass: "player-enable switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cellData.enable),
      expression: "cellData.enable"
    }],
    attrs: {
      "type": "checkbox",
      "id": 'player#' + _vm.cellIndex
    },
    domProps: {
      "checked": Array.isArray(_vm.cellData.enable) ? _vm._i(_vm.cellData.enable, null) > -1 : (_vm.cellData.enable)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.cellData.enable,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.cellData, "enable", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.cellData, "enable", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.cellData, "enable", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'player#' + _vm.cellIndex
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-248e7ff0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlayerCell.vue
// module id = 108
// module chunks = 2